import $ from 'jquery';
import {shareFbBtnHandler, quizShareFbBtnHandler} from "../common/dataLayer/data-layer-metrica-handlers";

export const handlerFbShareBtn = () => {
    $(document).on('click', '.fbSharingBtn', function (event) {
        event.preventDefault();

        shareFbBtnHandler();

        if ($(this).parents('.quiz-share-btn-container').length) {
            quizShareFbBtnHandler();
        }

        const shareUri = $(this).attr('href');

        const newWindow = window.open(shareUri, '', 'width=555,height=300');

        if (window.focus) {
            newWindow.focus();
        }

        return false;
    });
};
